// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container___xcF0","buttons":"RemoveExpirationActionButtons_buttons__3qk3q"};